import type { WidgetConfig } from '../types';

const DEFAULT_CONFIG: Partial<WidgetConfig> = {
  layout: 'weekly-calendar',
  showMoreMode: 'link',
  showMoreUrl: 'https://ondiem.com/practices',
  instance: 'default',
};

/**
 * Parses configuration from data-* attributes on the container element
 */
export function parseConfig(element: HTMLElement): WidgetConfig {
  const getAttribute = (name: string, defaultValue?: string): string | undefined => {
    const value = element.getAttribute(name);
    return value || defaultValue;
  };

  const layout = getAttribute('data-layout', DEFAULT_CONFIG.layout) as WidgetConfig['layout'];
  const showMoreMode = getAttribute('data-show-more-mode', DEFAULT_CONFIG.showMoreMode) as WidgetConfig['showMoreMode'];
  const showMoreUrl = getAttribute('data-show-more-url', DEFAULT_CONFIG.showMoreUrl) || '';
  const showMoreEnvRaw = element.getAttribute('data-show-more-environment');
  const showMoreEnvironment =
    showMoreEnvRaw === 'staging' || showMoreEnvRaw === 'production' ? showMoreEnvRaw : undefined;
  const instance = getAttribute('data-instance', DEFAULT_CONFIG.instance) || '';
  const utmContent = getAttribute('data-utm-content');
  const zipCode = getAttribute('data-zip-code') || null;
  const position = getAttribute('data-position') || null;
  const brandingRaw = element.getAttribute('data-branding');
  const branding: WidgetConfig['branding'] =
    brandingRaw === 'partner' || brandingRaw === 'plain' ? brandingRaw : 'auto';

  // Validate layout - fallback to weekly-calendar if invalid
  const validLayouts: WidgetConfig['layout'][] = [
    'weekly-calendar',
    'list',
    'compact',
    'calendar-only',
    'count-only',
  ];
  const validatedLayout = validLayouts.includes(layout) ? layout : 'weekly-calendar';

  return {
    layout: validatedLayout,
    showMoreMode,
    showMoreUrl,
    showMoreEnvironment,
    instance,
    utmContent,
    zipCode,
    position,
    branding,
  };
}
